import { z } from 'zod';
import { idSchema, projectColorSchema, softDeleteTimestampsSchema } from './common.js';
/**
 * Etiqueta. `projectId` a `null` significa etiqueta global, disponible en
 * todos los proyectos. Tiene borrado suave como el resto de entidades del
 * contrato: un borrado físico dejaría sin rastro las tareas que la llevaban.
 */
export const labelSchema = z
    .object({
    id: idSchema,
    projectId: idSchema.nullable(),
    name: z.string().min(1).max(40),
    color: projectColorSchema,
})
    .extend(softDeleteTimestampsSchema.shape);
export const createLabelRequestSchema = z.object({
    projectId: idSchema.nullable().optional(),
    name: z.string().min(1).max(40),
    color: projectColorSchema,
});
export const updateLabelRequestSchema = z
    .object({
    name: z.string().min(1).max(40),
    color: projectColorSchema,
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, {
    message: 'Se requiere al menos un campo',
});
export const listLabelsQuerySchema = z.object({
    projectId: idSchema.optional(),
    /** Papelera (CLAUDE.md §6, fase 5). */
    onlyDeleted: z.stringbool().default(false),
});
//# sourceMappingURL=label.js.map